<template>
  <div class="warehousing-detail">
    <el-card shadow="hover" >
      <!-- 列表 S -->
      <page-table ref='pageTable'
                  :refresh="refresh"
                  permission="warehousing"
                  :list="wareDetailList"
                  :fieldList="fieldList"
                  :page="page"
                  :size="size">
        <template v-slot:col-price="scope">
          {{scope.row.price | toFixed1}}
        </template>
        <template v-slot:col-num="scope">
          {{scope.row.num | tofixed}}
        </template>
        <template v-slot:col-money="scope">
          <label v-if="scope.row.isAcc == 1">-</label>
          <label v-else>{{scope.row.money | tofixed2}}</label>
        </template>
      </page-table>
      <!-- 列表 E -->
      <div style="text-align: right;">
        <span style="color: rgb(128, 128, 128);">费用合计：{{this.sum}}元</span>
      </div>
    </el-card>
  </div>
</template>

<script>
import pageTable from '@/components/Table/Index'
import dialogForm from '@/components/Form/DialogForm'
import costMenu from '../../store/costMenu/index.js'
import { WAREHOUSEDETAIL } from '../../store/costMenu/types.js'
import { mixin } from './components/mixins'
export default {
  name: 'warehousingdetai',
  components: {
    pageTable,
    dialogForm
  },
  data () {
    return {
      size: 10,
      page: 1,
      code: '',
      computeType: '',
      query: this.$route.query
    }
  },
  computed: {
    fieldList () {
      if (this.computeType !== 'RECKON_TYPE_M2_DAY') {
        return [
          { label: '商品编码', prop: 'goodsCode', align: 'center' },
          { label: '商品名称', prop: 'goodsName', align: 'center' },
          { label: '规格', prop: 'standard', align: 'center' },
          { label: '箱规(件/箱)', prop: 'box', align: 'center' },
          { label: '商品件数', prop: 'calculationNum', align: 'center' },
          { label: '计费单位', prop: 'calculationName', align: 'center' },
          { label: '计算数量', prop: 'num', align: 'center', type: 'slot' },
          { label: '单价（元）', prop: 'price', align: 'center', type: 'slot' },
          { label: '单项费用（元）', prop: 'money', align: 'center', type: 'slot' }
        ]
      }
      return [
        { label: '租赁编码', prop: 'leaseId', align: 'center' },
        { label: '租赁面积(㎡)', prop: 'area', align: 'center' },
        { label: '货位号', prop: 'goodsNum', align: 'center' },
        { label: '货位类型', prop: 'typeName', align: 'center' },
        { label: '单价（元）', prop: 'price', align: 'center', type: 'slot' },
        { label: '单项费用（元）', prop: 'money', align: 'center', type: 'slot' }
      ]
    },
    // 列表
    wareDetailList () {
      return costMenu.state.wareDetailList
    },
    sum () {
      let sum = 0
      if (this.wareDetailList.obj) {
        this.wareDetailList.obj.forEach((ele) => {
          if (ele.money) {
            sum += ele.money
          }
        })
      }
      return sum.toFixed(2)
    }
  },
  filters: {
    toFixed1 (val) {
      if (val) {
        val = val.toFixed(2)
      }
      return val
    }
  },
  watch: {
    // 重新请求数据
    $route (to, from) {
      if (this.$route.params.code) {
        this.code = this.$route.params.code
        this.computeType = this.$route.params.computeType
        this.getList()
      }
    }
  },
  mounted () {
    this.code = this.$route.params.code
    this.computeType = this.$route.params.computeType
    this.getList()
    // 获取下拉框
    // let params = {
    //   parentCode: ''
    // }
    // this.$store.dispatch(WAREHOUSEDETAIL, params)
  },
  methods: {
    // 分页刷新
    refresh (page, size) {
      this.page = page
      this.size = size
      this.getList()
    },
    // 请求数据列表
    getList () {
      let params = {
        code: this.code
      }
      this.$store.dispatch(WAREHOUSEDETAIL, params)
    }
  },
  mixins: [ mixin ]
}
</script>

<style scoped>
  .warehousing-detail .el-table {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/page/costMenu/WarehousingDetai.vue